// Beneficiary segmentation — Lenovo India CSR (FY 24-25)
// Colours follow the Red + Grey system.

export const BENEFICIARY_TYPES = [
  { type: "School Students",  value: 12000, gender: { female: 5760, male: 6240 }, pillar: "stem",           color: "#E2231A" },
  { type: "Teachers",         value: 1800,  gender: { female: 1080, male: 720  }, pillar: "stem",           color: "#B91C1C" },
  { type: "Girl Learners",    value: 6800,  gender: { female: 6800, male: 0    }, pillar: "digital",        color: "#374151" },
  { type: "Youth (Skilling)", value: 6000,  gender: { female: 2580, male: 3420 }, pillar: "employability",  color: "#6B7280" },
  { type: "Green Communities",value: 3200,  gender: { female: 1600, male: 1600 }, pillar: "sustainability", color: "#991B1B" },
];

export const RURAL_URBAN_SPLIT = { rural: 64, urban: 36 };

export const AGE_BANDS = [
  { band: "6–14",  value: 34, label: "School children",    description: "Primary & middle-school STEM and digital learners",  icon: "GraduationCap", color: "#E2231A" },
  { band: "15–18", value: 28, label: "Adolescents",        description: "Secondary students, coding & AI exposure",          icon: "BookOpen",      color: "#6B7280" },
  { band: "19–25", value: 26, label: "Youth & skilling",   description: "Job seekers in IT-ITES & manufacturing pathways",    icon: "Briefcase",     color: "#B91C1C" },
  { band: "26+",   value: 12, label: "Adults & teachers",  description: "Educators, farmers & community members",            icon: "Users",         color: "#374151" },
];
